import { useMatch, PathMatch } from 'react-router-dom';
import { RoutePaths } from 'types/enums';

const useCreatorRouteMatch = (): PathMatch<'session'> | null => {
    const session = useMatch(`/${RoutePaths.CreatorBeatMaker}/:session`);

    return session;
};

export default useCreatorRouteMatch;
